// Generated types for Constraint
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ConstraintKind, ConstraintStatus } from '../enums';

import { ExpressionReadAPI, ExpressionWriteAPI } from './expression';
import { ExpressionReadAPISchemaObject, ExpressionWriteAPISchemaObject } from './expression';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ConstraintReadAPI extends ExpressionReadAPI {
  /** Hard (must hold), Soft (preferred), Guideline (advisory). Demoting an existing constraint (hard→soft/guideline) weakens a stated obligation — that is a USER decision made for engineering reasons, never a way to stop a completeness rule from firing. */
  kind?: ConstraintKind;
  /** Evaluation verdict. New Constraints default to STALE — the orchestrator runs `evaluate()` and flips to PASSING / FAILING / UNKNOWN / NOT_APPLICABLE. The shared staleness flag is `Expression.is_stale` (orchestrator filters on that); `status` carries the Constraint-specific verdict. */
  status?: ConstraintStatus;
}

export interface ConstraintWriteAPI extends ExpressionWriteAPI {
  mentions?: string[];
  /** Hard (must hold), Soft (preferred), Guideline (advisory). Demoting an existing constraint (hard→soft/guideline) weakens a stated obligation — that is a USER decision made for engineering reasons, never a way to stop a completeness rule from firing. */
  kind?: ConstraintKind;
  /** The Requirement(s) this Constraint FORMALISES — the machine-checkable form of the requirement's obligation (SysML v2: the requirement's require/assume constraint; the `role` edge property carries which). Evaluation reaches the physical world through the requirement: owning part -> satisfier bindings -> committed allocation. A constraint never attaches to an LP or Port directly (masterplan/53, Formalises-only model). */
  formalises?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ConstraintReadAPISchema: z.ZodType<ConstraintReadAPI> = ExpressionReadAPISchemaObject.extend({
  kind: z.nativeEnum(ConstraintKind).optional(),
  status: z.nativeEnum(ConstraintStatus).optional(),
}).passthrough();

export const ConstraintWriteAPISchema: z.ZodType<ConstraintWriteAPI> = ExpressionWriteAPISchemaObject.extend({
  mentions: z.array(z.string()).optional(),
  kind: z.nativeEnum(ConstraintKind).optional(),
  formalises: z.array(z.string()).optional(),
}).passthrough();
